import {TourStep} from "@app-types/tour.types.ts";


export const checkoutTourSteps: TourStep[] = [
    {
        title: 'Seguimiento del progreso',
        description: 'Si comprás como invitado vas a ver los pasos a completar y el estado de cada uno en esta barra.',
        target: {
            class: '.ant-steps',
            allowHidden: true,
        },
        optional: true,
        onlyVisible: true,
    },
    {
        title: 'Ajustá cantidades',
        description: 'Podés editar cantidades directamente antes de confirmar la compra. El total se recalcula en tiempo real.',
        target: {
            class: '.editQtyBtnsClass',
        },
        onlyVisible: true,
        fullyInView: true,
    },
    {
        title: 'Quitá productos',
        description: 'Si necesitás descartar un ítem, podés hacerlo acá y te pedimos confirmación para evitar errores.',
        target: {
            class: '.removeFromCartClass',
        },
        onlyVisible: true,
        fullyInView: true,
    },
    {
        title: 'Aplicá beneficios',
        description: 'Ingresá tus cupones o vales promocionales y mirá el ahorro reflejado al instante.',
        target: {
            class: '.voucherClass',
        },
        onlyVisible: true,
        fullyInView: true,
    },
    {
        title: 'Resumen de totales',
        description: 'Acá ves subtotal, descuentos y estimado de envío. Revisalo antes de avanzar.',
        target: {
            class: '.totalsCartSectionClass',
        },
        onlyVisible: true,
        fullyInView: true,
    },
    {
        title: 'Retiro o envío',
        description: 'Alterná entre retiro en sucursal o envío a domicilio. Guardamos tu preferencia para próximos pedidos.',
        target: {
            class: '.switchTakeAwayClass',
        },
        optional: true,
        onlyVisible: true,
        fullyInView: true,
    },
    {
        title: 'Direcciones y contacto',
        description: 'Completá o elegí tu dirección guardada. Validamos los datos básicos para evitar demoras en la entrega.',
        target: {
            class: '.shippingAddressFormClass',
        },
        onlyVisible: true,
        fullyInView: true,
    },
    {
        title: 'Métodos de envío',
        description: 'Comparamos costo y tiempos estimados. También vas a ver notas o requisitos del proveedor.',
        target: {
            class: '.shippingSectionClass',
            allowHidden: true,
        },
        optional: true,
        onlyVisible: true,
        fullyInView: true,
    },
    {
        title: 'Medios de pago',
        description: 'Seleccioná cómo querés pagar. Si algún método requiere instrucciones extra, las mostramos acá mismo.',
        target: {
            class: '.paymentMethodSectionClass',
        },
        onlyVisible: true,
        fullyInView: true,
    },
    {
        title: 'Previsualizar pedido',
        description: 'Antes de confirmar, revisá el resumen final. Desde este botón abrís la vista previa y confirmás cuando todo esté listo.',
        target: {
            class: '.paymentBtnClass',
        },
        onlyVisible: true,
        fullyInView: true,
    },
];

